import spinModel from "../../model/SpinModel";
import betModel from "../../model/BetModel";

import { ICondition } from "../State";
import GameModel from "../../model/GameModel";

export class HasBigWinCondition implements ICondition {
    public check(): boolean {
        return this.hasSpecificBigWin();
    }

    private hasSpecificBigWin(): boolean {
        return this.getWinRatio() >= (GameModel.gameConfig as any).bigWinRatioLevels[0];
    }

    private getWinRatio() {
        return spinModel.winAmount / betModel.totalBet;
    }
}
